import React from 'react';

const SocialCommitment = () => {
  return (
    <div 
      className="w-full py-6 sm:py-8 md:py-12 lg:py-16 xl:py-20 2xl:py-0"
      style={{
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(66, 255, 0, 0.5) 100%)'
      }}
    >
      <div className="max-w-7xl mx-auto  ">
        <div className="flex flex-col lg:flex-row items-center gap-6 sm:gap-8 md:gap-10 lg:gap-16 xl:gap-20">
          {/* Left side - Text Content */}
          <div className="w-full lg:w-1/2 p-3 sm:p-4 md:p-6 lg:p-8 xl:p-10 2xl:p-12 text-center lg:text-left">
            <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
              <div className="space-y-1 sm:space-y-2 md:space-y-3">
                <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold font-source text-[#113861] leading-tight">
                  Our Commitment
                </h2>
                <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-normal italic font-source text-[#113861] leading-tight">
                  to the Social Sector
                </h3>
              </div>
              
              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg mx-auto lg:mx-0">
                  Clarity belongs to everyone. In partnership with NGOs, charities and grassroots groups, we bring our Cognitive & Identity Insights to underserved communities, supporting career insight, life skills and confidence, one clear decision at a time.
                </p>
              </div>
            </div>
          </div>

          {/* Right side - Commitment Image */}
          <div className="w-full lg:w-1/2 relative flex items-center justify-center">
            <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-6xl translate-y-4 sm:translate-y-6 md:translate-y-8 lg:translate-y-10 xl:translate-y-12 2xl:translate-y-14">
              <img 
                src="/images/commitment.png" 
                alt="Our Commitment to the Social Sector" 
                className="w-full h-48 sm:h-56 md:h-64 lg:h-80 xl:h-[500px] 2xl:h-[620px] object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialCommitment;
